import { RootContainer } from '../../../../core/root_container';
import { RecentCheckedItemAction } from '../../../../core/actions/recent_checked_item/recent_checked_item_action';
import { RecentCheckedItemJsEnv, RecentCheckedItem } from '../../../models/recent_checked_item/recent_checked_item_js_env';
import { RecentCheckedItemBody } from './recent_checked_item_body';
import { applyCarouselStyle } from '../../common/carousel_util';
import { getNoPhotoImageUrl } from '../../../models/common/static_resource_util'

import {
  FooterRecentCheckItems
} from '../../../../../../trylion-template/dist_components/esm/index';
import ReactDOM from 'react-dom';

export class RecentCheckedItemContainer extends RootContainer<RecentCheckedItemJsEnv> {
  constructor(model: RecentCheckedItemJsEnv) {
    super();
    this.mount(RecentCheckedItemBody, 'js-recent-checked-item-body');

    renderRecentCheckItems(model, this.getElement('js-recent-checked-item-body'));

    // item pageを更新するイベント
    RecentCheckedItemAction.UPDATE_EVENT.on((model: RecentCheckedItemJsEnv) => {
      renderRecentCheckItems(model, this.getElement('js-recent-checked-item-body'));
      applyCarouselStyle(['recent_checked_item_carousel']);
    });

    applyCarouselStyle(['recent_checked_item_carousel']);
  }
}

function renderRecentCheckItems(model, element) {
  let items = model.recentCheckedItems.map((item) => {
    return {
      href: `/p/${buildItemUrl(item)}/`,
      img: item.imageUrl !== '' ? item.imageUrl : getNoPhotoImageUrl(),
      deleteBtnOnClick: () => RecentCheckedItemAction.delete(item.supplierId, item.catalogItemCode)
    };
  });

  ReactDOM.render(
    <FooterRecentCheckItems
      isSp={false}
      listLinkHref={"/as/recentchecked/recentChecked/"}
      carouselItems={items}
    />,
    element
  );
}

const buildItemUrl = (recentCheckedItem: RecentCheckedItem) => {
  if (recentCheckedItem.supplierId === 'P00001') {
    return recentCheckedItem.catalogItemCode;
  } else {
    return recentCheckedItem.supplierId + '-' + recentCheckedItem.catalogItemCode;
  }
};
